import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import FilterModal from './FilterModal';

interface Props {
  selectedFilters: {
    theme: string[];
    region: string[];
    category: string[];
    date: string;
  };
  setSelectedFilters: React.Dispatch<
    React.SetStateAction<{
      theme: string[];
      region: string[];
      category: string[];
      date: string;
    }>
  >;
}

function QuantFilter({ selectedFilters, setSelectedFilters }: Props) {
  const dateInputRef = useRef<HTMLInputElement>(null);
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const openDatePicker = () => {
    dateInputRef.current?.showPicker(); // 브라우저 기본 datepicker 열기
  };

  const getSelectedFilterCount = () => {
    const { theme, region, category } = selectedFilters;
    return theme.length + region.length + category.length;
  };

  const selectedFilterCount = getSelectedFilterCount();

  const setDate = (values: string) => {
    setSelectedFilters((prev) => ({
      ...prev,
      ['date']: values,
    }));
  };

  const handleFocus = (event: any) => {
    event.target.showPicker();
  };

  const formatDateToKorean = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; // 유효하지 않은 날짜 방지
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
  };

  return (
    <FilterBox>
      <FilterLeft
        onClick={() => setFilterModalOpen(true)}
        active={selectedFilterCount > 0}
      >
        <img
          src={
            selectedFilterCount > 0
              ? '/assets/images/icon/filter_blue.svg'
              : '/assets/images/icon/filter_dark_gray.svg'
          }
          width={16}
          height={16}
          alt="filter"
        />
        필터
        {selectedFilterCount > 0 && (
          <span style={{ marginLeft: '2px' }}>+{selectedFilterCount}</span>
        )}
      </FilterLeft>

      <FilterRightWrapper>
        <label>
          <FilterRight
            // onClick={() => {
            //   openDatePicker();
            // }}
            active={selectedFilters['date'] !== ''}
          >
            분석일
            {selectedFilters['date'] &&
              ` ・ ${formatDateToKorean(selectedFilters['date'])}`}
            <img
              src={
                selectedFilters['date']
                  ? '/assets/images/icon/calendar_blue.svg'
                  : '/assets/images/icon/calendar.svg'
              }
              width={16}
              height={16}
              alt="calendar"
            />
          </FilterRight>
          <HiddenDateInput
            ref={dateInputRef}
            type="date"
            onFocus={handleFocus}
            value={selectedFilters['date']}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
        </label>
      </FilterRightWrapper>
      {filterModalOpen && (
        <FilterModal
          onClose={() => setFilterModalOpen(false)}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      )}
    </FilterBox>
  );
}

export default QuantFilter;

const FilterBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Tablist = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Tab = styled.button<{ selected?: boolean }>`
  padding: 7px 12px;
  border-radius: 9999px;
  background-color: ${({ selected }) => (selected ? '#70737C14' : 'white')};
  cursor: pointer;

  font-weight: ${({ selected }) => (selected ? 700 : 500)};
  color: ${({ selected }) => (selected ? '#222222' : '#616161')};

  &:hover {
    background-color: #0000000a;
  }
`;

const FilterRight = styled.div<{ active?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 2px;
  padding-top: 7px;
  padding-right: 8px;
  padding-bottom: 7px;
  padding-left: 12px;
  border-radius: 8px;

  background-color: ${({ active }) => (active ? '#EAF2FE' : '#70737c14')};

  font-weight: 500;
  font-size: 13px;
  text-align: center;
  color: ${({ active }) => (active ? '#008AFF' : '#616161')};
  cursor: pointer;

  &:hover {
    background-color: #70737c14;
  }
`;

const FilterLeft = styled(FilterRight)`
  padding-top: 7px;
  padding-left: 8px;
  padding-bottom: 7px;
  padding-right: 12px;
`;

const FilterRightWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const HiddenDateInput = styled.input`
  position: absolute;
  right: 0;
  top: 40px;
  width: 0;
  height: 0;
  opacity: 0;
`;
